import React from 'react';
import PropTypes from 'prop-types';
import styles from './SelectablePill.module.scss';
import omit from 'lodash-es/omit';

function SelectablePill(props) {
  return (
    <div className={styles.container + ' ' + props.className + ' ' + props.theme} >
      <input
        {...omit(props, ['className'])}
        type='checkbox'
        value={props.selected}
        disabled={props.disabled}
        checked={props.selected}
        name={props.id}
      />
      <label htmlFor={props.id} className={styles.pillBody}>
        { props.label }
      </label>
    </div>
  );
}

SelectablePill.THEME = {
  orange: styles.themeOrange,
  white: styles.themeWhite,
  dark: styles.themeDark,
};

SelectablePill.defaultProps = {
  theme: SelectablePill.THEME.dark
};

SelectablePill.propTypes = {
  theme: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default SelectablePill;